import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";

const ResetPassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = React.useState({
    username: localStorage.getItem("userEmail") || "",
    password: "",
    repeatPassword: ""
  });

  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  useEffect(() => {
    if (!formData.username) {
      setError("No email found. Please restart the process.");
    }
  }, [formData.username]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&._])[A-Za-z\d@$!%*?&._]{8,}$/;
    return passwordRegex.test(password);
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);

    const { username, password, repeatPassword } = formData;

    if (!username || !password || !repeatPassword) {
      setError("All fields are required.");
      setLoading(false);
      return;
    }
    if (password !== repeatPassword) {
      setError("Passwords do not match!");
      setLoading(false);
      return;
    }
    if (!validatePassword(password)) {
      setError(
        "Password must be at least 8 characters long, include a number, a special character, and an uppercase letter."
      );
      setLoading(false);
      return;
    }

    try {
      await ApiService.post("/api/auth/reset-password", {
        email: username,
        password
      });

      toast.success("Password reset successfully! Redirecting to login...", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });

      setTimeout(() => {
        navigate("/login");
      }, 2100);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  return (

    <div className="tyn-root">
      <div className="tyn-content tyn-auth tyn-auth-centered">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <div className="card border-0 py-4">
                <div className="my-3 text-center d-flex align-items-center justify-content-center">
                  <Link className="tyn-logo tyn-logo-sm" to="/">
                    <img
                      src="/images/logo/bardo-icon.png"
                      alt="Bardo logo"
                      className="logo-icon"
                    />
                    <img
                      src="/images/logo/bardo-text.png"
                      alt="Bardo logo"
                      className="logo-text"
                    />
                  </Link>
                </div>
                <form className="p-4" onSubmit={handlePasswordReset}>
                  <h3>Create new password</h3>
                  <div className="row g-3 gx-4">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label className="form-label">Email Address</label>
                        {formData.username ? (
                          <p>{formData.username}</p>
                        ) : (
                          error && <p className="text-danger small">{error}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group position-relative">
                        <label className="form-label" htmlFor="password">Password</label>
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="New Password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <span
                          className="position-absolute end-0 pb-5 mt-1 translate-middle-y pe-3 cursor-pointer"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i
                            className={`bi ${!showPassword ? "bi-eye-slash" : "bi-eye"
                              }`}
                          ></i>
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group position-relative">
                        <label className="form-label" htmlFor="repeatPassword">Repeat Password</label>
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="repeatPassword"
                          name="repeatPassword"
                          placeholder="Repeat Password"
                          value={formData.repeatPassword}
                          onChange={handleChange}
                        />
                        <span
                          className="position-absolute end-0 pb-5 mt-1 translate-middle-y pe-3 cursor-pointer"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i
                            className={`bi ${!showPassword ? "bi-eye-slash" : "bi-eye"
                              }`}
                          ></i>
                        </span>
                      </div>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                        {loading ? "Resetting..." : "Reset Password"}
                      </button>
                    </div>
                  </div>
                </form>
                <div className="text-center my-3 ">
                  <p>
                    Remembered your password? {" "}
                    <Link
                      to="/login"
                      className="link link-primary"
                      style={{ fontSize: "16px" }}
                    >
                      Log In.
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
